/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"#e62214\"/><path fill=\"#FFF\" d=\"M7 4h2v4H7zm0 6h2v2H7z\"/></g></svg>\n";
//# sourceMappingURL=alert-round.svg.js.map